import Resource from '@/api/Resource';
import FileHelper from '@/helpers/file';

export default class extends Resource {
  $name = 'task-files';
  $helper;

  constructor(data = null) {
    super(data);
    this.$helper = new FileHelper(data);
  }

  static makeFromFile(file, data = {}) {
    data.path = file;
    data.name = file.name;
    data.size = file.size;
    data.type = file.type;

    return new this(data);
  }

  $defaults() {
    return {
      id: null,
      task_id: 0,
      task_message_id: 0,
      path: '',
      download_url: '',
      name: '',
      description: '',
      size: 0,
      type: '',
      extension: '',
      created_at: null,
    };
  }

  isImage() {
    return this.$helper.isImage();
  }
  getImageUrl() {
    return this.isImage() ? this.$helper.getImageUrl() : null;
  }
}
